import { Text } from '@chakra-ui/react'
import React from 'react'

export default function MsgCallback({errorMsg, SuccessMsg}) {
  return (
    <div>
    {
        errorMsg.status && (
            <Text mt={"10px"} color="red" textAlign="center">{errorMsg.msg}</Text>
        )
    }

    {
        SuccessMsg.status && (
            <Text mt={"10px"} color="green" textAlign="center">{SuccessMsg.msg}</Text>
        )
    }

    </div>
  )
}
